var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00032 15.3335C12.0504 15.3335 15.3337 12.0503 15.3337 8.0002C15.3337 3.95011 12.0504 0.66687 8.00032 0.66687C3.95024 0.66687 0.666992 3.95011 0.666992 8.0002C0.666992 12.0503 3.95024 15.3335 8.00032 15.3335Z",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 4.66687L9.33366 9.33354L4.66699 11.3335L6.66699 6.66687L11.3337 4.66687Z",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 4.66687L9.33366 9.33354L6.66699 6.66687L11.3337 4.66687Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.4fafafcf.svg";
export { ForwardRef as ReactComponent };